import { FunctionComponent } from 'react';
import { Backspace } from '../icons';
import { Typography } from './../../tailwindcomponents';
import { Button } from '../../tailwindcomponents';

type LoginDigitsPinProps = {
  pin: string,
  onAddNumber: Function,
  onRemoveNumber: Function,
  onClearAllNumber: Function,
  errorMessage: string
}
const LoginDigitsPin: FunctionComponent<LoginDigitsPinProps> = ({ pin, onAddNumber, onRemoveNumber, onClearAllNumber, errorMessage }) => {
  return (
    <div>
      <Typography text={pin.replace(/./g, '*')} align='center' variant='h3' fontWeight='bolder' />
      <Typography text={errorMessage} align='center' fontWeight='bolder' color='error' />
      <div className="flex flex-wrap w-full">
        <div className="w-1/4"></div>
        <div className="flex flex-wrap w-1/2 justify-center" >
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("1")}>1</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("2")}>2</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("3")}>3</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("4")}>4</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("5")}>5</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("6")}>6</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("7")}>7</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("8")}>8</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("9")}>9</Button> </div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onClearAllNumber()}>A/C</Button></div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onAddNumber("0")}>0</Button></div>
          <div className="flex flex-wrap w-1/3 justify-center"><Button variant="text" className="text-2xl" onClick={() => onRemoveNumber()}><Backspace /></Button></div>
        </div>
      </div>
    </div>
  );
};
export default LoginDigitsPin




